module.exports = __webpack_public_path__ + "img/matadero.b86f777c.png";